export default "__VITE_ASSET__DTyLe8e5__"